<template>
	<div :style="page_style()">
		<RotationIndicator class="rotation_indicator" :style="rotate_dir()"/>

		<div class="center">
			<CardRenderer
				v-for="card in discard" :key="card.key"
				:type="card"
				:style="card.style"
			/>
		</div>
		<OtherPlayer
			v-for="(p, index) in player_data.slice(player ? 1 : 0)" :key="index"
			class="other-player-display" :style="player_visual_data[index + (player ? 1 : 0)].style"
			:angle="player_visual_data[index + (player ? 1 : 0)].ang"
			:player_name="p.name"
			:amount_cards="p.amount_cards"
			:player_index="p.player_index"
			:selecting="selecting_seven_target"

			@click="click_player(index + 1)"
		/>
		<div id="cards" v-if="player">
			<Card
				v-for="(card, i) in player_hand" :key="card.key"
				:type="card"
				:index="i"
				:playable="($store.state.game_data.playable_cards == null) ? null : $store.state.game_data.playable_cards.includes(card.index)"
				:num_cards="player_hand.length"
				:playing="playing()"
				@click="click_card(card.index)"
				:style="{ 'z-index': i }"
			/>
		</div>

		<UnoCall ref="uno_call" :style="uno_call_style"/>

		<transition name="uno_and_skip">
			<div
				class="uno_and_skip"
				:style="br_style_vars"
				v-if="player && ($store.state.game_data.can_call_uno || ($store.state.game_data.drawing && $store.state.game_data.playable_cards != null))"
			>
				<UnoButton
					class="br_inner"
					@click="call_uno"
					v-if="$store.state.game_data.can_call_uno"
				/>
				<SkipCard
					class="br_inner"
					@click="skip"
					v-else-if="$store.state.game_data.drawing && $store.state.game_data.playable_cards != null"
				/>
			</div>
		</transition>

		<Deck v-if="!$store.state.mobile && player" id="deck" @click="draw"/>
		<Button v-else-if="player" id="draw_button" @click="draw">Draw</Button>

		<div v-if="player" id="selecting_color" :style="{ transform: `scale(${(selecting_color ? 1.0 : 0.0)})` }">
			<ColorChooseRed @click="choose_color('Red')" class="card_choose"/>
			<ColorChooseGreen @click="choose_color('Green')" class="card_choose"/>
			<ColorChooseYellow @click="choose_color('Yellow')" class="card_choose"/>
			<ColorChooseBlue @click="choose_color('Blue')" class="card_choose"/>
		</div>
	</div>
</template>

<style>
@keyframes card_played {
	0% {
		transform:
			translate(-50%, -50%)
			translate(var(--offx), var(--offy))
			rotate(var(--rot))
			scale(1.5);
		opacity: 0;
	}
	100% {
		transform:
			translate(-50%, -50%)
			translate(var(--offx), var(--offy))
			rotate(var(--rot))
			scale(1.0);
		opacity: 1;
	}
}

@keyframes rotation_indicator_anim {
	0% {
		transform: translate(-50%, -50%) scaleX(var(--rotate_dir)) rotate(0deg);
	}
	40% {
		transform: translate(-50%, -50%) scaleX(var(--rotate_dir)) rotate(180deg);
	}
	100% {
		transform: translate(-50%, -50%) scaleX(var(--rotate_dir)) rotate(180deg);
	}
}

@keyframes uno_call_anim {
	0% {
		transform: translate(-50%, 50%) scale(0);
		opacity: 0;
	}
	60% {
		transform: translate(-50%, 50%) scale(0.6);
		opacity: 1;
	}
	100% {
		transform: translate(-50%, 50%) scale(1.0);
		opacity: 0;
	}
}
</style>

<style scoped>
#draw_button {
	position: absolute;
	bottom: 2%;
	left: 2%;
	width: 96%;
	height: 30px;
}

#deck {
	position: absolute;
	left: 2%;
	bottom: 2%;
	width: 110px;
	height: auto;
	cursor: pointer;
	pointer-events: none;
	overflow: visible;
}

.top_deck_card {
	transition: 0.2s;
	transform-origin: 154.897px 4.905px;
	transform: rotate(46.144deg);
}

#deck:hover .top_deck_card {
	transform: translate(6%, -6%) rotate(46.144deg);
}

.uno_and_skip, .uno_and_skip-enter-active, .uno_and_skip-leave-active {
	transition: all .3s ease;
	position: absolute;
	right: var(--right);
	bottom: var(--bottom);
	transform: translateX(var(--translate));
	cursor: pointer;
	pointer-events: none;
}
.uno_and_skip-enter, .uno_and_skip-leave-to {
	transform: translateX(var(--translate)) scale(0);
}

.br_inner {
	transition: all .3s ease;
	width: 110px;
	height: auto;
}
.br_inner:hover {
	transform: scale(1.1);
}

#selecting_color {
	transition: all .3s ease;
	position: absolute;
	left: 50%;
	top: 50%;
	z-index: 10000;
}

.card_choose {
	position: absolute;
	left: 50%;
	top: 50%;
	width: min(50vh, 80vw);
	height: min(50vh, 80vw);
	transform: translate(-50%, -50%);
	transform-origin: 50% 50%;
	transition: 0.3s;
	pointer-events: none;
	cursor: pointer;
}

.card_choose:hover {
	transform: translate(-50%, -50%) scale(1.2);
}

#cards {
	margin: 0 auto;
	left: 0;
	right: 0;
	bottom: 0;
}

.center {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.rotation_indicator {
	position: absolute;
	left: 50%;
	top: 50%;
	width: 40%;
	height: 40%;
	animation: rotation_indicator_anim 4.0s ease infinite;
}

.uno_call {
	animation: uno_call_anim 1.0s linear;
}
</style>

<script lang="ts">
import Vue from "vue"

import OtherPlayer from "../components/OtherPlayer.vue"
import Card from "../components/Card.vue"
import CardRenderer from "../components/CardRenderer.vue";

import Deck from "@/assets/deck.svg";

import ColorChooseRed from "@/assets/color_choose_red.svg";
import ColorChooseGreen from "@/assets/color_choose_green.svg";
import ColorChooseYellow from "@/assets/color_choose_yellow.svg";
import ColorChooseBlue from "@/assets/color_choose_blue.svg";

import RotationIndicator from "@/assets/rotation_indicator.svg";

import UnoButton from "@/assets/uno_button.svg";
import SkipCard from "@/assets/skip_card.svg";

import UnoCall from "@/assets/uno_call.svg";

export default Vue.extend({
	components: {
		OtherPlayer,
		Card,
		CardRenderer,
		Deck,
		ColorChooseRed,
		ColorChooseGreen,
		ColorChooseYellow,
		ColorChooseBlue,
		RotationIndicator,
		UnoButton,
		SkipCard,
		UnoCall
	},
	data() {
		return {
			selecting_color: false,
			wild_index: null,

			selecting_seven_target: false,
			seven_index: null,

			discard: [],
			uno_call_pos: [0, 0, 0]
		};
	},
	created() {
		let top = this.$store.state.game_data.top_card;
		var wild_color = null;
		if (top.type == "Wild" || top.type == "WildDrawFour") {
			wild_color = this.$store.state.game_data.cur_color;
		}
		this.add_discard(top, wild_color);

		this.$store.state.connection.addEventListener("message", this.on_message);
	},
	beforeDestroy() {
		this.$store.state.connection.removeEventListener("message", this.on_message);
	},
	methods: {
		on_message(event) {
			var obj = JSON.parse(event["data"]);
			if (obj[0] == "card_played_event") {
				this.add_discard(obj[1].card, obj[1].wild_color);
			}
			if (obj[0] == "uno_called_event") {
				let data = this.$store.state.game_data;
				let loop_player_index =
						(obj[1].who - (this.player ? data.player_index : 0)) % data.player_data.length;

				if (this.player && loop_player_index == 0) return;

				this.uno_call_pos = this.get_position(loop_player_index);
				this.$refs.uno_call.classList.remove("uno_call");
				if (document.visibilityState == "visible") {
					setTimeout(() => {
						this.$refs.uno_call.classList.add("uno_call")
					}, 1);
				}
			}
		},
		page_style() {
			var col = "inherit";
			if (!this.$store.state.dark) {
				switch (this.$store.state.game_data.cur_color) {
				case "Red": col = "#F6C0C0"; break;
				case "Green": col = "#DEF7DE"; break;
				case "Yellow": col = "#F7E2B6"; break;
				case "Blue": col = "#DBDBFA"; break;
				}
			} else {
				switch (this.$store.state.game_data.cur_color) {
				case "Red": col = "#330404"; break;
				case "Green": col = "#082108"; break;
				case "Yellow": col = "#362904"; break;
				case "Blue": col = "#0b0b26"; break;
				}
			}
			return {
				padding: "4px",
				position: "relative",
				height: "100%",
				flex: "1",
				overflow: "hidden",
				"background-color": col,
				transition: "1.0s"
			};
		},
		rotate_dir() {
			return {
				"--rotate_dir": this.$store.state.game_data.pos_direction ? "1.0" : "-1.0"
			};
		},
		call_uno() {
			var obj = [
				"call_uno",
				{}
			];
			this.$store.state.connection.send(JSON.stringify(obj));
		},
		choose_color(col) {
			if (this.selecting_color && this.wild_index != null) {
				var obj = [
					"play_card",
					{
						index: this.wild_index,
						wild_color: col
					}
				];
				this.$store.state.connection.send(JSON.stringify(obj));
				this.selecting_color = false;
				this.wild_index = null;
			}
		},
		click_player(index) {
			if (this.selecting_seven_target && this.seven_index != null) {
				let real_index =
					(index + this.$store.state.game_data.player_index) %
					this.$store.state.game_data.player_data.length;

				var obj = [
					"play_card",
					{
						index: this.seven_index,
						wild_color: null,
						seven_target: real_index
					}
				];
				this.$store.state.connection.send(JSON.stringify(obj));
				this.selecting_seven_target = false;
				this.seven_index = null;
			}
		},
		add_discard(card, wild_color) {
			let offx = (Math.random() * 2 - 1) * 20;
			let offy = (Math.random() * 2 - 1) * 20;
			let rot = (Math.random() * 2 - 1) * Math.PI / 2;
			if (wild_color != null) {
				card.color_override = wild_color;
			}
			card.key = Math.random();

			let height = Math.max(Math.min(120, window.innerWidth / 10), 80);

			card.style = {
				height: height + 'px',
				width: height * 0.63 + 'px',
				position: "absolute",
				"--offx": offx + "%",
				"--offy": offy + "%",
				"--rot": rot + "rad",
				transform:
					"translate(-50%, -50%)" +
					"translate(var(--offx), var(--offy))" +
					"rotate(var(--rot))" + 
					"scale(1.0)",
				opacity: 1,
				animation: "card_played 0.6s ease"
			};

			if (this.discard.length >= 10) this.$delete(this.discard, 0);
			if (this.discard.length > 0) {
				this.discard[this.discard.length - 1].style.animation = undefined;
			}
			this.discard.push(card);
		},
		card_number(card) {
			if (card.type == "Wild") return 2000 + card.which;
			if (card.type == "WildDrawFour") return 3000 + card.which;
			var base = 0;
			switch (card.color) {
			case "Red": base = 0; break;
			case "Green": base = 100; break;
			case "Yellow": base = 200; break;
			case "Blue": base = 300; break;
			}
			var i = 0;
			switch (card.type) {
			case "Number": i = card.num; break;
			case "Reverse": i = 10; break;
			case "Plus2": i = 11; break;
			case "Skip": i = 12; break;
			}
			return 4 * (base + i) + card.which;
		},
		get_position(index) {
			let ang = index * (2.0 * Math.PI / this.player_data.length);
			let pos_ang = -Math.PI / 2.0 - ang;
			let circx = Math.cos(pos_ang) * 0.75;
			let circy = Math.sin(pos_ang) * 0.75;
			return [0.5 + 0.5 * circx, 0.5 + 0.5 * circy, ang + Math.PI];
		},
		playing() {
			var data = this.$store.state.game_data;
			if (data == null || data.type != "Playing") return false;
			return data.cur_player == data.player_index;
		},
		skip() {
			if (this.selecting_color) {
				this.selecting_color = false;
				return;
			}

			var obj = [
				"skip_card",
				{}
			];
			this.$store.state.connection.send(JSON.stringify(obj));
		},
		click_card(index) {
			if (!this.playing()) return;
			if (this.$store.state.game_data.playable_cards != null && !this.$store.state.game_data.playable_cards.includes(index)) return;

			if (this.selecting_color) {
				this.selecting_color = false;
				return;
			}
			if (this.selecting_seven_target) {
				this.selecting_seven_target = false;
				return;
			}

			let card = this.$store.state.game_data.player_hand[index];
			if (card.type == "Wild" || card.type == "WildDrawFour") {
				this.selecting_color = true;
				this.wild_index = index;
				return;
			}
			if (
				this.$store.state.game_data.house_rules.seven_zero &&
				card.type == "Number" && card.num == 7
			) {
				this.selecting_seven_target = true;
				this.seven_index = index;
				return;
			}

			var obj = [
				"play_card",
				{
					index,
					wild_color: null,
				}
			];
			this.$store.state.connection.send(JSON.stringify(obj));
		},
		draw() {
			var obj = [
				"draw_card",
				{}
			];
			this.$store.state.connection.send(JSON.stringify(obj));
		}
	},
	computed: {
		player() {
			return this.$store.state.game_data.client_type == "Player";
		},
		br_style_vars() {
			return {
				"--right": this.$store.state.mobile ? "50%" : "2%",
				"--bottom": this.$store.state.mobile ? "160px" : "2%",
				"--translate": this.$store.state.mobile ? "50%" : "0%"
			}
		},
		uno_call_style() {
			return {
				position: "absolute",
				left: this.uno_call_pos[0] * 100.0 + "%",
				bottom: this.uno_call_pos[1] * 100.0 + "%",
				transform: "translate(-50%, 50%) scale(0)",
				width: "40vw",
				height: "auto"
			};
		},
		player_visual_data() {
			let styles = [...this.player_data.keys()].map((index) => {
				let position = this.get_position(index);
				return {
					style: {
						position: "absolute",
						left: position[0] * 100.0 + '%',
						bottom: position[1] * 100.0 + '%',
					},
					ang: position[2]
				};
			});
			return styles;
		},
		player_data() {
			var data = this.$store.state.game_data;
			if (data == null || data.type != "Playing") return [];
			var ret = [];
			for (var i = 0; i < data.player_data.length; i++) {
				let loop_player_index =
					((this.player ? data.player_index : 0) + i) % data.player_data.length;
				var d = data.player_data[loop_player_index];
				d.player_index = loop_player_index
				ret.push(d);
			}
			return ret;
		},
		player_hand() {
			var data = this.$store.state.game_data;
			if (data == null || data.type != "Playing") return [];
			var hand = [...data.player_hand];
			hand.forEach((c, i) => {
				c.index = i;
				c.key = this.card_number(c);
			});
			hand.sort(
				(l, r) => this.card_number(l) - this.card_number(r)
			);
			return hand;
		}
	}
})
</script>
